<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{ team: undefined }"
  />

  @if (teams.length) {
    <app-sidebar-items-divider />
  }

  @if (teams.length) {
    <app-sidebar-item
      title="Teams"
      icon="sapphire-groups"
      class="rounded hover:bg-hover"
      [depth]="0"
      [expandable]="true"
      [expanded]="expanded | lsValue"
      [minimized]="minimized"
      [toggleOnClick]="!minimized"
      (onExpand)="expanded.set($event)"
      stchPopover
      [stchPopoverContent]="popoverTemplate"
      stchPopoverPlacement="right"
      [stchPopoverDisabled]="!minimized"
      stchPopoverTrigger="click"
      />
  }

  @if (!minimized && teams.length) {
    <div
      class="collapseable-body"
      [@heightAnimation]="(expanded | lsValue) ? 'show' : 'hide'"
      >
      <ng-container *ngTemplateOutlet="contentTemplate" />
    </div>
  }

  <ng-template #popoverTemplate>
    @if (minimized) {
      <div
        class="popover-body"
        >
        <ng-container *ngTemplateOutlet="contentTemplate" />
      </div>
    }
  </ng-template>

  <ng-template #contentTemplate>
    @for (team of teams; track team) {
      <app-sidebar-item
        [title]="team.title"
        icon="sapphire-groups"
        class="rounded hover:bg-hover"
        [depth]="1"
        [expandable]="true"
        [expanded]="expanded | lsValue : team.id"
        [minimized]="minimized"
        [toggleOnClick]="true"
        (onExpand)="expanded.set($event, team.id)"
        >
        <stch-members-avatars
          [members]="team.participants"
          stchPopover
          [stchPopoverTemplate]="membersTemplate"
          [stchPopoverContext]="{ team: team }"
          stchPopoverPlacement="right"
          stchPopoverTrigger="click"
          />
        </app-sidebar-item>
        <div
          class="collapseable-body"
          [@heightAnimation]="(expanded | lsValue : team.id) ? 'show' : 'hide'"
          >
          <ng-container
            [ngTemplateOutlet]="template"
            [ngTemplateOutletContext]="{ team: team }"
            />
          </div>
        }
      </ng-template>

      <ng-template #membersTemplate let-team="team" let-close="close">
        <stch-members-popover
          [team]="team"
          (onClose)="close?.next()"
          />
        </ng-template>
